import styled from "@emotion/styled";

export const TitleWrapper = styled.div(({theme}) => ({
  gridColumn: theme?.breakpoints?.isMobile ? "1/-1" : "2/15",
}));

export const TextWrapper = styled.div(({theme, isImg}) => ({
  gridColumn: theme?.breakpoints?.isMobile ? "1/-1" : "3/15",
  marginTop: 40,
  marginBottom: theme?.breakpoints?.isMobile || !isImg ? 30 : 50,
}));

export const HashtagsWrapper = styled.div(({theme}) => ({
  display: "flex",
  gap: 10,
  marginTop: theme?.breakpoints?.isMobile ? 17 : 24,
}));

export const Image = styled.img(({theme}) => ({
  gridColumn: theme?.breakpoints?.isMobile ? "1/-1" : "2/16",
  width: "100%",
  height: "auto",
  objectFit: "cover",
  objectPosition: "cover",
  marginTop: theme?.breakpoints?.isMobile ? 15 : 40,
  borderRadius: 24,
  aspectRatio: theme?.breakpoints?.isMobile ? "1/1" : "16/9",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
}));
